import React from 'react';
import './OfferCard.css';

interface Offer {
  id: string;
  name: string;
  description: string;
  icon: string | null;
  type: string;
  action: string;
  featured?: boolean;
  payout?: number;
  category?: string;
}

interface OfferCardProps {
  offer: Offer;
  userId?: string;
}

const OfferCard: React.FC<OfferCardProps> = ({ offer, userId }) => {
  const formatDescription = (text: string): string => {
    if (!text) return '';

    // Convert to sentence case: first letter uppercase, rest lowercase
    // but preserve punctuation and capitalize after periods
    const sentences = text.split(/(?<=[.!?])\s+/);
    return sentences.map(sentence => {
      const trimmed = sentence.trim();
      if (!trimmed) return '';
      return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
    }).join(' ');
  };

  const handleInstallClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event bubbling to parent div

    // Construct the tracking link for GoTap
    const intermediaryUrl = 'https://intermediary-server-production.up.railway.app';
    console.log('intermediaryUrl', intermediaryUrl);
    console.log('userId', userId);
    console.log('offer.id', offer);
    if (userId && offer.id) {
      console.log('userId', userId);
      console.log('offer.id', offer.id);
      const trackingUrl = `${intermediaryUrl}/gotap/click?offer_id=${offer.id}&user_id=${userId}`;
      console.log('trackingUrl', trackingUrl);
      window.open(trackingUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleCardClick = (e: React.MouseEvent) => {
    // Only trigger if clicking the card itself, not the button
    if ((e.target as HTMLElement).closest('.offer-action-btn')) {
      return;
    }
    handleInstallClick(e);
  };

  return (
    <div className={`offer-card ${offer.featured ? 'featured' : ''}`} onClick={handleCardClick}>
      <div className="offer-content">
        <div className="offer-icon">
          {offer.icon ? (
            <img src={offer.icon} alt={offer.name} />
          ) : (
            <div className="offer-icon-placeholder">
              <span>{offer.name.charAt(0)}</span>
            </div>
          )}
        </div>
        <div className="offer-details">
          <h3 className="offer-name">{offer.name}</h3>
          <p className="offer-description">{formatDescription(offer.description)}</p>
          {/* <div className="offer-meta">
            {offer.type && <span className="offer-type">#{offer.type}</span>}
            {offer.payout && <span className="offer-payout">${offer.payout.toFixed(2)}</span>}
            {offer.category && <span className="offer-category">{offer.category}</span>}
          </div> */}
        </div>
      </div>
      <button className="offer-action-btn" onClick={handleInstallClick}>
        <span>Install</span>
      </button>
    </div>
  );
};

export default OfferCard;